import { BUILDING_BLOCKS_MODEL_TYPES } from '../../../constants';

import Benefits from '../../../components/Benefits/components';
import GigsCarousel from '../../../components/GigsCarousel/component';

export default {
    [BUILDING_BLOCKS_MODEL_TYPES.BENEFITS]: Benefits,
    [BUILDING_BLOCKS_MODEL_TYPES.GIGS_CAROUSEL]: GigsCarousel
};
